export function parseIntWithDefaultNull(value: unknown): number | null {
  if (typeof value === 'number') {
    return value;
  }
  if (typeof value !== 'string') {
    return null;
  }
  const parsedValue = parseInt(value, 10);
  if (Number.isNaN(parsedValue)) {
    return null;
  }
  return parsedValue;
}
